import { makeRoute } from '~/utils/route';

import template from './e2e-smartfield.html';
import controller from './e2e-smartfield.controller';

export default makeRoute({
	template,
	controller,
	title:      'e2e smartfield',
	path:       '/e2e/smartfield',
	onlyDev:    true,
});
